export function getNavigationLink(coordinates: { latitude: number; longitude: number }) {
  return `https://www.google.com/maps/dir/?api=1&dir_action=navigate&travelmode=driving&destination=${coordinates.latitude},${coordinates.longitude}`;
}
